import React from 'react';
import animationData from './saleLoaderAnimation.json';
import './SaleLoader.scss';
import ThemedLottie from '../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../utilities/theme/ThemeColorEnum';

const SaleLoader = () => {
    return (
        <div className='sale-loader'>
            <ThemedLottie
                animationData={animationData}
                layerColors={{
                    1: ThemeColorEnum.PRIMARY,
                    2: ThemeColorEnum.LIGHT,
                }}
                height="100px"
                width="100px"
                loop
                autoplay
            />
        </div>
    );
};

export default SaleLoader;
